import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import CloudSaveModel from '@/CloudSaveModel';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import CloudSaveReadModel from '@/CloudSaveReadModel';
import CloudGpxInfo from '@/CloudGpxInfo';
import CloudGpxInfoShared from '@/CloudGpxInfoShared';
import QueryStringUtility from './QueryStringUtility';

export class CloudSaveServiceStatic {
    CloudSaveDelete(prefix: string, gpxUrl: string): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/subscriber/cloudsave/${prefix}${QueryStringUtility.getQueryString({gpxUrl})}`
        return AxiosPostProcessor.postProcess(Axios.delete(url, AxiosDefaultRequestConfig.merge({ })));
    }

    CloudSaveGetPrivate(gpxUrl: string): Promise<AxiosResponse<CloudSaveReadModel>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/subscriber/cloudsave/r${QueryStringUtility.getQueryString({gpxUrl})}`
        return AxiosPostProcessor.postProcess(Axios.get<CloudSaveReadModel>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    CloudSaveGetPublic(gpxUrl: string): Promise<AxiosResponse<CloudSaveReadModel>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/cloudsave/u${QueryStringUtility.getQueryString({gpxUrl})}`
        return AxiosPostProcessor.postProcess(Axios.get<CloudSaveReadModel>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    CloudSavePrivate(model: CloudSaveModel): Promise<AxiosResponse<CloudGpxInfo>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/subscriber/cloudsaveprivate`
        return AxiosPostProcessor.postProcess(Axios.put<CloudGpxInfo>(url, model, AxiosDefaultRequestConfig.merge({ })));
    }

    CloudSavePublic(model: CloudSaveModel): Promise<AxiosResponse<CloudGpxInfoShared>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/subscriber/cloudsavepublic`
        return AxiosPostProcessor.postProcess(Axios.put<CloudGpxInfoShared>(url, model, AxiosDefaultRequestConfig.merge({ })));
    }
}
const CloudSaveService = new CloudSaveServiceStatic();
export default CloudSaveService;
